import React from "react";
import { useQuery } from "react-query";
import { Skeleton } from "primereact/skeleton";
import { getUserMadePayments } from "../../../services/ClientArea/getUserMadePayments";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";
import { Button } from "primereact/button";
import { useAppContext } from "../../../context/AppContext";

const UserMadePayments = () => {
  const { permissions } = useAppContext();
  const { data, isLoading } = useQuery({
    queryKey: ["UserMadePayments"],
    queryFn: () => getUserMadePayments(),
    retry: false,
    enabled: !!permissions?.includes("1"),
  });

  const columns = [
    { field: "id", header: "Fatura" },
    {
      field: "desc",
      header: "Descrição",
    },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-danger";
            labelText = "Pendente";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Pago";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "14px",
              marginLeft: "5px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "value",
      header: "Valor",
      body: (rowData) => {
        return formatCurrency(rowData.value);
      },
    },
    {
      field: "due_date",
      header: "Vencimento",
      body: (rowData) => {
        return formatDate(rowData.due_date);
      },
    },
    {
      field: "payment_value",
      header: "Valor Pago",
      body: (rowData) => {
        return formatCurrency(rowData.payment_value);
      },
    },
    {
      field: "payment_date",
      header: "Data do Pagamento",
      body: (rowData) => {
        return formatDate(rowData.payment_date);
      },
    },
  ];

  //  console.log(data);
  return (
    <div className="row pb-4">
      {isLoading ? (
        <Skeleton width="100%" height={400} />
      ) : (
        <>
          {data && (
            <DataTable
              rows={5}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              rowsPerPageOptions={[5, 25, 100]}
              value={data}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  editor={col.editor}
                  body={col.body}
                />
              ))}
              {/* <Column
                header="Recibo"
                body={(rowData) => (
                  <div className="text-center">
                    <Button
                      label="Recibo"
                      //   onClick={() => setVisible(true)}
                      type="button"
                      outlined
                      icon={`fa-solid fa-download`}
                    />
                  </div>
                )}
              /> */}
            </DataTable>
          )}
        </>
      )}
    </div>
  );
};

export default UserMadePayments;
